import { Dispatch, SetStateAction } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import {
  ToolsRoles,
  isAbleToSeeUIElement,
} from '../../../utils/roles/client-roles';
import { pagesConfig } from '../../../shared/pages-config';
import { useNavigate } from 'react-router-dom';
import SharedToolbar from '../../../shared/shared-toolbar-latest';
import SharedGridStateIconButton from '../../../shared/shared-grid-state-icon-button-latest';
import { ModuleList } from '../../../shared/analytics/module-list';
import CreateButton from '../../../shared/buttons/create-button';
import SharedIconButton from '../../../shared/buttons/shared-icon-button';
interface GmailDeletionToolbarProps {
  toolsRoles: string[];
  selectedGmailDeletions: number[];
  setOpenDeleteGmailDeletions: Dispatch<SetStateAction<boolean>>;
}

export default function GmailDeletionToolbar({
  toolsRoles,
  selectedGmailDeletions,
  setOpenDeleteGmailDeletions,
}: GmailDeletionToolbarProps) {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return (
    <SharedToolbar
      primaryButtons={
        <CreateButton
          disabled={
            !isAbleToSeeUIElement(toolsRoles, ToolsRoles.ViewGmailSearch.value)
          }
          onClick={() =>
            navigate(
              `/${pagesConfig.gmailDeletion.link}/${pagesConfig.createGmailDeletionFormPage.link}`
            )
          }
          label="Create Gmail Deletion"
          tooltipLabel={
            !isAbleToSeeUIElement(toolsRoles, ToolsRoles.ViewGmailSearch.value)
              ? `You are missing the ${ToolsRoles.ViewGmailSearch.name} permission to perform this action.`
              : ''
          }
        />
      }
      secondaryButtons={
        <>
          <SharedIconButton
            variant="delete"
            onClick={() => {
              setOpenDeleteGmailDeletions(true);
            }}
            disabled={
              selectedGmailDeletions.length === 0 ||
              !isAbleToSeeUIElement(
                toolsRoles,
                ToolsRoles.DeleteGmailSearch.value
              )
            }
            tooltipLabel={
              !isAbleToSeeUIElement(
                toolsRoles,
                ToolsRoles.DeleteGmailSearch.value
              )
                ? `You are missing the ${ToolsRoles.DeleteGmailSearch.name} permission to perform this action.`
                : 'Delete'
            }
          />
          <SharedIconButton
            variant="refresh"
            onClick={() => {
              queryClient.invalidateQueries({
                queryKey: ['GmailDeletionModels'],
              });
            }}
            tooltipLabel="Refresh"
          />
          <SharedGridStateIconButton
            gridStateKey="gmailDeletionsGridStates"
            module={ModuleList.modules.importExport.name}
            section={ModuleList.modules.importExport.sections.gmailDeletion}
          />
        </>
      }
    />
  );
}
